export default __webpack_public_path__ + "static/media/PrimroseChareka.105af57c.jfif";